(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["seloria-models"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.seloria-models__swatch');
    if (!swatch) return;

    const picker = swatch.closest('.seloria-models__colors');
    if (!picker) return;

    picker.querySelectorAll('.seloria-models__swatch').forEach((el) => {
      el.classList.remove('is-selected');
      el.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('is-selected');
    swatch.setAttribute('aria-pressed', 'true');

    const nameEl = picker.querySelector('.seloria-models__colors-value');
    if (nameEl) nameEl.textContent = swatch.dataset.colorName || '';

    const item = picker.closest('.seloria-models__item');
    const img = item ? item.querySelector('.seloria-models__media img') : null;
    if (img && swatch.dataset.image) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = swatch.dataset.image;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
